export default "__VITE_ASSET__WoYVTSet__"